import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const updateAssignDepartment = createAsyncThunk('updateAssignDepartment', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: process.env.REACT_APP_API_URL + 'assign_department',
            data: {
                "assign_id": data?.values?.id,
                "staff_id": data?.values?.staff,
                "department_id": data?.values?.department,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})